import { Component, ContentChildren, OnInit, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { TableCellComponent } from '../table-cell/table-cell.component';

@Component({
  selector: 'ff-table-row',
  templateUrl: './table-row.component.html',
  styleUrls: ['./table-row.component.scss']
})
export class TableRowComponent implements OnInit {
  @ContentChildren(TableCellComponent) cellTemplates: QueryList<TableCellComponent>;

  @ViewChild('rowTemplate') template: TemplateRef<any>;
  
  constructor() { }

  ngOnInit(): void {
  }

}
